<script setup>
import { storeToRefs } from 'pinia'

import { HelpTextTooltip, TextField } from '@haskoning/vue-component-library'

import { useCalculationStore } from '@/stores/calculation'

import {
  BERTHING_POINT_LEVEL,
  BERTHING_POINT_Y,
  MAXIMUM_NUMBER_OF_LINES,
  MIN_LINE_LENGTH,
  MOORING_POINT_LEVEL,
  MOORING_POINT_Y,
  PLATFORM_WIDTH,
  WATER_LEVEL,
  X1,
  X2,
  Y_LOCATION_PLATFORM
} from '@/constants/calculationFieldConstants'

const calculationStore = useCalculationStore()

const { currentItem, fields } = storeToRefs(calculationStore)
</script>

<template>
  <div>
    <v-list-item>
      <v-row class="mt-2 mb-0">
        <v-col cols="6" class="py-0">
          <TextField
            v-if="fields[MOORING_POINT_LEVEL]"
            no-help-text
            :item-key="MOORING_POINT_LEVEL"
            :field="fields[MOORING_POINT_LEVEL]"
            :model-value="currentItem"
            :step="0.1"
            warning
            :warning-rules="[
              {
                min_value: currentItem[WATER_LEVEL],
                message: `Mooring dolphin level is lower than the water level`
              },
              {
                max_value: currentItem[WATER_LEVEL] + 10,
                message: `Mooring dolphin level larger than 10m above water level are relatively high`
              }
            ]"
            @update="calculationStore.update()"
          ></TextField>
        </v-col>
        <v-col cols="6" class="py-0">
          <TextField
            v-if="fields[BERTHING_POINT_LEVEL]"
            no-help-text
            :item-key="BERTHING_POINT_LEVEL"
            :field="fields[BERTHING_POINT_LEVEL]"
            :model-value="currentItem"
            :step="0.1"
            warning
            :warning-rules="[
              {
                min_value: currentItem[WATER_LEVEL],
                message: `Berthing dolphin level is lower than the water level`
              },
              {
                max_value: currentItem[WATER_LEVEL] + 10,
                message: `Berthing dolphin level larger than 10m above water level are relatively high`
              }
            ]"
            @update="calculationStore.update()"
          ></TextField>
        </v-col>
        <v-col cols="6" class="py-0">
          <TextField
            v-if="fields[MOORING_POINT_Y]"
            :item-key="MOORING_POINT_Y"
            :field="fields[MOORING_POINT_Y]"
            :model-value="currentItem"
            :step="0.1"
            @update="calculationStore.update()"
          ></TextField>
        </v-col>
        <v-col cols="6" class="py-0">
          <TextField
            v-if="fields[BERTHING_POINT_Y]"
            :item-key="BERTHING_POINT_Y"
            :field="fields[BERTHING_POINT_Y]"
            :model-value="currentItem"
            :step="0.1"
            @update="calculationStore.update()"
          ></TextField>
        </v-col>

        <v-col cols="6" class="py-0">
          <TextField
            :item-key="MAXIMUM_NUMBER_OF_LINES"
            :field="fields[MAXIMUM_NUMBER_OF_LINES]"
            :model-value="currentItem"
            @update="calculationStore.update()"
          ></TextField>
        </v-col>
        <v-col cols="6" class="py-0">
          <TextField
            :item-key="MIN_LINE_LENGTH"
            :field="fields[MIN_LINE_LENGTH]"
            :model-value="currentItem"
            @update="calculationStore.update()"
          ></TextField>
        </v-col>
      </v-row>
    </v-list-item>
    <v-divider></v-divider>
    <v-list-item>
      <v-list-item-title class="pr-3 py-2">
        <span> Platform size and location </span>
        <HelpTextTooltip
          text="Define the size and location of the (rectangular) jetty platform (Y-coordinate is lateral distance of the platform front behind the berthing line; width is distance from platform front to rear)"
          size="small"
        ></HelpTextTooltip>
      </v-list-item-title>
      <v-row class="my-0">
        <v-col cols="6" class="py-0">
          <TextField
            v-if="fields[Y_LOCATION_PLATFORM]"
            :item-key="Y_LOCATION_PLATFORM"
            :field="fields[Y_LOCATION_PLATFORM]"
            :model-value="currentItem"
            :step="0.5"
            @update="calculationStore.update()"
          ></TextField>
        </v-col>
        <v-col cols="6" class="py-0">
          <TextField
            v-if="fields[PLATFORM_WIDTH]"
            style="z-index: 1"
            :item-key="PLATFORM_WIDTH"
            :field="fields[PLATFORM_WIDTH]"
            :model-value="currentItem"
            :step="0.5"
            warning
            :warning-rules="[
              {
                min_value: 10,
                message: 'This is a relatively small platform width.'
              }
            ]"
            @update="calculationStore.update()"
          ></TextField>
        </v-col>
        <v-col cols="6" class="py-0">
          <TextField
            v-if="fields[X1]"
            :item-key="X1"
            :field="fields[X1]"
            :model-value="currentItem"
            @update="calculationStore.update()"
          ></TextField>
        </v-col>
        <v-col cols="6" class="py-0">
          <TextField
            v-if="fields[X2]"
            :item-key="X2"
            :field="fields[X2]"
            :model-value="currentItem"
            @update="calculationStore.update()"
          ></TextField>
        </v-col>
      </v-row>
    </v-list-item>
  </div>
</template>
